import {sendRequest} from '@js/utils';
import initHeatMap from '@js/modules/public/infographics/charts/heatMap';
import initCountryWeightPie from '@js/modules/public/infographics/charts/countryWeightPie';
import initCountryUnionPieChart from '@js/modules/public/infographics/charts/countryWeightInUnionPie';
import chartErrorsHandler from '@js/helpers/chart';

$(() => {
    import(/* webpackChunkName: "highchart" */'@entries/chart').then(() => {
        const $infographicWrapper = $('.infographic__wrapper');
        sendRequest('get', '/infographics/getStatistic', {}, (res) => {
            if (res?.success) {
                if (res?.data?.stat) {
                    initHeatMap(res.data.stat);
                    const countriesInSelect = res.data.stat
                        .filter(({percentage}) => {
                            return percentage >= 1;
                        })
                        .map(({id}) => {
                            const countryId = parseInt(id, 10);
                            return res.data.spr.countriesList[countryId];
                        });
                    setCountriesOnSelect(res.data.selectedCountry, countriesInSelect);

                    const {stat} = res.data;
                    const {relationCountryIdWithUnions, countriesUnionsList} = res.data.spr;
                    Object.keys(relationCountryIdWithUnions)
                        .forEach((index) => {
                            const countryIds = relationCountryIdWithUnions[index];
                            relationCountryIdWithUnions[index] = countryIds.map((id) => {
                                return parseInt(id, 10);
                            });
                        });
                    const selectedCountryId = getSelectedCountryId();
                    toggleCountryUnionSelectWrapper(relationCountryIdWithUnions, selectedCountryId, countriesUnionsList, stat);
                    initCountryWeightPie(stat, selectedCountryId);

                    $('body')
                        .on('change', '#countries', () => {
                            const selectedCountryId = getSelectedCountryId();
                            toggleCountryUnionSelectWrapper(relationCountryIdWithUnions, selectedCountryId, countriesUnionsList, stat);
                            initCountryWeightPie(stat, selectedCountryId);
                        })
                        .on('change', '#countries_union', function () {
                            const selectedCountryId = getSelectedCountryId();
                            const selectedCountryUnionId = parseInt($(this)
                                .val(), 10);
                            const countryIdsInSelectedUnion = relationCountryIdWithUnions[selectedCountryUnionId];
                            initCountryUnionPieChart(stat, countryIdsInSelectedUnion, selectedCountryId);
                        });
                } else {
                    chartErrorsHandler($infographicWrapper);
                }
            } else {
                chartErrorsHandler($infographicWrapper);
            }
        });
    });
});

function setCountriesOnSelect(selectCountryId, options) {
    const $countriesSelect = $('#countries');
    $countriesSelect.empty();
    options.forEach((option) => {
        $countriesSelect.append(`<option value="${option.id}">${option.name_en_short_official}</option>`);
    });
    $countriesSelect.selectpicker({
        noneResultsText: 'По запросу {0} ничего не найдено',
        noneSelectedText: 'Все',
        size: 15,
    });
    $countriesSelect.closest('.countries__wrapper').show();
    $countriesSelect.val(selectCountryId);
    $countriesSelect.selectpicker('refresh');
    return selectCountryId;
}

function getSelectedCountryId() {
    return parseInt($('#countries').val(), 10);
}

function getCountryUnions(relationCountryIdWithUnions, selectedCountryId) {
    const countryUnions = [];
    Object.keys(relationCountryIdWithUnions)
        .forEach((sprUnionId) => {
            const countryIds = relationCountryIdWithUnions[sprUnionId];
            if (countryIds.includes(selectedCountryId)) {
                countryUnions.push(parseInt(sprUnionId, 10));
            }
        });
    return countryUnions;
}

function setCountryUnionsOnSelect(options) {
    const $countriesUnionSelect = $('#countries_union');
    $countriesUnionSelect.empty();
    options.forEach((option) => {
        $countriesUnionSelect.append(`<option value="${option.id}">${option.name}</option>`);
    });
    return $countriesUnionSelect.val();
}

function toggleCountryUnionSelectWrapper(relationCountryIdWithUnions, selectedCountryId, countriesUnionsList, stat) {
    const countryUnions = getCountryUnions(relationCountryIdWithUnions, selectedCountryId);
    if (countryUnions.length) {
        const options = countryUnions.map((countyId) => {
            return countriesUnionsList[countyId];
        });
        const selectedCountryUnionId = setCountryUnionsOnSelect(options);
        const countryIdsInSelectedUnion = relationCountryIdWithUnions[selectedCountryUnionId];
        initCountryUnionPieChart(stat, countryIdsInSelectedUnion, selectedCountryId);
        $('#piePresenceCountryOnUnionInRankingWrapper').show();
    } else {
        $('#piePresenceCountryOnUnionInRankingWrapper').hide();
    }
}
